export const download_cloud = () => (
  <path
    d="M8 17l4 4m0 0l4-4m-4 4v-9m8.88 6.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
